import { commonFacebookEventsUtil } from '@/shared/features/analytics/utils/facebookCommonAttributes';
import type { PdpDeliveryStoreItemVm } from '../viewModels/pdpDelivery.vm';

export function facebookStoreInventoryViewed(stores: PdpDeliveryStoreItemVm[]): void {
  if (!stores.length) return;

  const firstStore = stores[0];
  commonFacebookEventsUtil('StoreInventoryViewed', {
    store_id: firstStore.storeId,
    store_name: firstStore.storeName,
    city: firstStore.cityName,
    content_category: '',
    content_ids: [],
    result_count: String(stores.length),
    source_page: 'pdp',
  });
}
